import React from 'react'
import { Box, BoxProps } from '@mui/material'
import { useScrollReveal, UseScrollRevealOptions } from '../../hooks/useScrollReveal'

export interface RevealProps extends BoxProps {
  /** Stagger delay in ms — pass `index * 60` for a list */
  delay?: number
  scrollOptions?: UseScrollRevealOptions
}

/** `Box` wrapper around `useScrollReveal` — the `.rise` fade/rise-in-on-scroll treatment as a component. */
export const Reveal = React.forwardRef<HTMLDivElement, RevealProps>(function Reveal(
  { delay = 0, scrollOptions, style, ...rest },
  forwardedRef,
) {
  const { ref, inView } = useScrollReveal<HTMLDivElement>(scrollOptions)

  return (
    <Box
      ref={(node: HTMLDivElement | null) => {
        ref.current = node
        if (typeof forwardedRef === 'function') forwardedRef(node)
        else if (forwardedRef) (forwardedRef as React.MutableRefObject<HTMLDivElement | null>).current = node
      }}
      style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(18px)',
        transition: `opacity 640ms var(--ds-ease-out) ${delay}ms, transform 640ms var(--ds-ease-out) ${delay}ms`,
        ...style,
      }}
      {...rest}
    />
  )
})
